import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SignInRequired = ({ featureName, children }) => {
  const { user, guestMode } = useAuth();
  const navigate = useNavigate();

  // If user is logged in, show the actual content
  if (user) {
    return children;
  }

  // If in guest mode, show sign-in prompt
  if (guestMode) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className="mb-6">
              <div className="mx-auto w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                <svg 
                  className="w-8 h-8 text-purple-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Sign In Required
              </h2>
              <p className="text-gray-600 mb-1">
                {featureName || 'This feature'} requires you to be signed in
              </p>
              <p className="text-sm text-gray-500">
                Create an account or sign in to access all features and save your progress
              </p>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => navigate('/login')}
                className="w-full py-3 px-6 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition-colors shadow-sm"
              >
                Sign In / Create Account
              </button>
              <button
                onClick={() => navigate('/')}
                className="w-full py-3 px-6 border-2 border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Back to Meal Planner
              </button>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 mb-3">
                ✨ Benefits of creating an account:
              </p>
              <ul className="text-sm text-left text-gray-600 space-y-2">
                <li className="flex items-start">
                  <span className="mr-2">📊</span>
                  <span>Track your daily nutrition and calorie intake</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">💾</span>
                  <span>Save and manage your meal plans</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">🍽️</span>
                  <span>Create and store custom meals</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">🎯</span>
                  <span>Set personalized nutrition goals</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Fallback (shouldn't reach here due to routing)
  return children;
};

export default SignInRequired;
